<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'GlobalFooter',
})
</script>
<template>
  <div class="footer">
    <!-- <div :class="['links', isMobile ? 'lessMargin' : '']">
      <a href="https://github.com/bailihuiyue/ant-design-pro-vue3/blob/main/README.md" target="_blank">Pro 首页</a>
    </div> -->
    <div class="copyright">
      <!-- <div>Copyright ©2005-2026云枢智教智慧教育平台系统 ICP备:粤ICP2021001550号</div> -->
          <div>Copyright ©2005-2026美研教育科技有限公司 ICP备:京ICP2021001550号</div>
    </div>
  </div>
</template>

<script lang="ts" setup name="GlobalFooter">
import { CopyrightOutlined, GithubOutlined } from '@ant-design/icons-vue'
import { isMobile } from '@/utils/device'
</script>

<style lang="less" scoped>
.footer {
  padding: 0 16px;
  margin: 24px 0;
  text-align: center;

  .links {
    margin-bottom: 8px;

    a {
      color: rgba(0, 0, 0, 0.45);

      &:hover {
        color: rgba(0, 0, 0, 0.65);
      }

      &:not(:last-child) {
        margin-right: 40px;
      }
    }

    &.lessMargin {
      a {
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }
  }
  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
</style>
